import { useIntl } from 'react-intl-next';

import { getSuccessIntegrationFlag, getSlackDisconnectedFlag } from './getFlag';

export const useThirdPartyIntegrationsFlags = () => {
	const intl = useIntl();

	return {
		success: (serviceKey: string, workspace?: string) =>
			getSuccessIntegrationFlag(serviceKey, intl, workspace),
		slackDisconnect: () => getSlackDisconnectedFlag(intl),
	};
};
